// admin
export const GET_CAPABILITIES = "GET_CAPABILITIES"
export const GET_CAPABILITIES_SUCCESS = "GET_CAPABILITIES_SUCCESS"
export const GET_CAPABILITIES_FAIL = "GET_CAPABILITIES_FAIL"

export const UPDATE_CAPABILITIES = "UPDATE_CAPABILITIES"
export const UPDATE_CAPABILITIES_SUCCESS = "UPDATE_CAPABILITIES_SUCCESS"
export const UPDATE_CAPABILITIES_FAIL = "UPDATE_CAPABILITIES_FAIL"